export default "__VITE_ASSET__DDAuQ0Wt__"